import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=75d15bfa&"
import script from "./Bookmark.vue?vue&type=script&lang=js&"
export * from "./Bookmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports